import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/mnt/d/Projects/newcold-web/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/d/Projects/newcold-web/packages/web/src/components/Accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/d/Projects/newcold-web/packages/web/src/components/cards/NewsCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/d/Projects/newcold-web/packages/web/src/components/ContentButton.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/packages/web/src/components/CustomLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/d/Projects/newcold-web/packages/web/src/components/forms/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/d/Projects/newcold-web/packages/web/src/components/IframeWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/d/Projects/newcold-web/packages/web/src/components/IncrementingNumber.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/d/Projects/newcold-web/packages/web/src/components/map/MapWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/d/Projects/newcold-web/packages/web/src/components/NewsOverviewContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/mnt/d/Projects/newcold-web/packages/web/src/components/PeopleCard.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/packages/web/src/components/Story.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/packages/web/src/slices/CardListSection.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/packages/web/src/slices/CarouselHoverSection.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/packages/web/src/slices/ContentSectionCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/packages/web/src/slices/CountdownSection.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/packages/web/src/slices/FormSection.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/packages/web/src/slices/heroes/ImageTextBlockHero.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/packages/web/src/slices/heroes/OffsetHero.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/packages/web/src/slices/ImageCarouselSection.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/packages/web/src/slices/StoryHighlightSection.tsx");
;
import(/* webpackMode: "eager" */ "/mnt/d/Projects/newcold-web/packages/web/src/slices/VideosSection.tsx");
